import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import i18n from '@/plugins/i18n'
import vuescroll from 'vuescroll';


Vue.config.productionTip = false

Vue.use(vuescroll)

window.Office.initialize = () => {
  new Vue({
    i18n,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
}